import { mount } from "@vue/test-utils";
import DocumentType from "@/components/core/composite/combos/DocumentType";

jest.mock("@/components/core/composite/combos/DocumentType", () => ({
  ...jest.requireActual("@/components/core/composite/combos/DocumentType"),
  default: {}
}));

describe("DocumentType test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(DocumentType);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component DocumentType", () => {
    expect(wrapper).toBeDefined();
  });
});
